<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="400px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>设备详情</span>
    </div>
    <div class="megBox">
      <ul>
        <li
          v-for="(item, index) in vehicleDetail"
          :key="index"
        >
          <span class="title">{{item.title}}:</span>
          {{item.value}}
        </li>
      </ul>
    </div>

    <template slot="footer">
      <el-button
        type="primary"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >确定</el-button>
      <!-- <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button> -->

    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Array,
      default: undefined
    }
  },

  data() {
    return {
      vehicleDetail: [
        { title: "激活时间", value: "暂无数据" },
        { title: "电池编号", value: "暂无数据" },
        { title: "电池类型", value: "暂无数据" },
        { title: "创建时间", value: "暂无数据" },
        { title: "安装时间", value: "暂无数据" },
        // { title: "组织ID", value: "暂无数据" },
        { title: "组织名称", value: "暂无数据" },
        // { title: "IP地址", value: "暂无数据" },
        // { title: "续费多少个月", value: "暂无数据" },
        { title: "服务密码", value: "暂无数据" },
        { title: "SIM号", value: "暂无数据" },
        { title: "设备号", value: "暂无数据" },
        { title: "设备类型", value: "暂无数据" },
        // { title: "更新时间", value: "暂无数据" },
        // { title: "终端ID", value: "暂无数据" },
        { title: "备注", value: "暂无数据" }
      ]
    };
  },

  watch: {
    params(val) {
      if (!val) return;
      this.vehicleDetail = val;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 5px 20px;
}
.megBox {
  ul {
    li {
      margin: 15px 0;
      span {
        color: rgb(175, 173, 173);
        margin-right: 5px;
      }
    }
  }
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
